import { __decorate } from "tslib";
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonV2Module, IconV3Component } from '../../basic-features';
import { TranslateModule } from '@ngx-translate/core';
import { ConstructorName } from '../../shared';
import { DialogModule } from 'primeng/dialog';
import * as i0 from "@angular/core";
import * as i1 from "@ngx-translate/core";
import * as i2 from "../../basic-features/button-v2/button.component";
import * as i3 from "primeng/dialog";
let SystemStatusDialogComponent = class SystemStatusDialogComponent {
  showDialog = false;
  iconName = '32px_c-warning';
  severity = 'info';
  title = '';
  message = '';
  actionButtonLabel = 'X.BUTTON.CLOSE';
  actionButtonLoading = false;
  actionButtonClicked = new EventEmitter();
  iconColor = 'active-blue';
  ngOnChanges(changes) {
    if (changes['severity']) {
      switch (this.severity) {
        case 'info':
          this.iconColor = 'active-blue';
          break;
        case 'error':
          this.iconColor = 'orange';
          break;
        case 'success':
          this.iconColor = 'green';
          break;
      }
    }
  }
  onActionButtonClick() {
    this.actionButtonClicked.emit();
  }
  static ɵfac = function SystemStatusDialogComponent_Factory(t) {
    return new (t || SystemStatusDialogComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: SystemStatusDialogComponent,
    selectors: [["geaui-system-status-dialog"]],
    inputs: {
      showDialog: "showDialog",
      iconName: "iconName",
      severity: "severity",
      title: "title",
      message: "message",
      actionButtonLabel: "actionButtonLabel",
      actionButtonLoading: "actionButtonLoading"
    },
    outputs: {
      actionButtonClicked: "actionButtonClicked"
    },
    standalone: true,
    features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
    decls: 13,
    vars: 20,
    consts: [["styleClass", "system-status-dialog", 3, "visibleChange", "visible", "modal", "closable", "showHeader"], [1, "system-status-container"], [1, "system-message-container"], [3, "clickable", "file", "color"], [1, "gea-font-heading-20"], [1, "gea-font-body-16"], ["type", "secondary", 3, "click", "flex", "sending"]],
    template: function SystemStatusDialogComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "p-dialog", 0);
        i0.ɵɵtwoWayListener("visibleChange", function SystemStatusDialogComponent_Template_p_dialog_visibleChange_0_listener($event) {
          i0.ɵɵtwoWayBindingSet(ctx.showDialog, $event) || (ctx.showDialog = $event);
          return $event;
        });
        i0.ɵɵelementStart(1, "div", 1)(2, "div", 2);
        i0.ɵɵelement(3, "geaui-icon-v3", 3);
        i0.ɵɵelementStart(4, "span", 4);
        i0.ɵɵtext(5);
        i0.ɵɵpipe(6, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 5);
        i0.ɵɵtext(8);
        i0.ɵɵpipe(9, "translate");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(10, "geaui-button-v2", 6);
        i0.ɵɵlistener("click", function SystemStatusDialogComponent_Template_geaui_button_v2_click_10_listener() {
          return ctx.onActionButtonClick();
        });
        i0.ɵɵtext(11);
        i0.ɵɵpipe(12, "translate");
        i0.ɵɵelementEnd()()();
      }
      if (rf & 2) {
        i0.ɵɵtwoWayProperty("visible", ctx.showDialog);
        i0.ɵɵproperty("modal", true)("closable", false)("showHeader", false);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("clickable", false)("file", ctx.iconName)("color", ctx.iconColor);
        i0.ɵɵadvance();
        i0.ɵɵclassMap(ctx.severity);
        i0.ɵɵadvance();
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 14, ctx.title));
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(9, 16, ctx.message), " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("flex", true)("sending", ctx.actionButtonLoading);
        i0.ɵɵadvance();
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 18, ctx.actionButtonLabel), " ");
      }
    },
    dependencies: [CommonModule, IconV3Component, TranslateModule, i1.TranslatePipe, ButtonV2Module, i2.ButtonV2Component, DialogModule, i3.Dialog],
    styles: [".system-status-container[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding:40px 0;max-width:368px;gap:40px}.system-status-container[_ngcontent-%COMP%]   .system-message-container[_ngcontent-%COMP%]{display:flex;flex-direction:column;gap:16px;text-align:center;align-items:center}.system-status-container[_ngcontent-%COMP%]   .error[_ngcontent-%COMP%]{color:var(--geaui-radiant-orange)}.system-status-container[_ngcontent-%COMP%]   .info[_ngcontent-%COMP%]{color:var(--geaui-active-blue-120)}.system-status-container[_ngcontent-%COMP%]   .success[_ngcontent-%COMP%]{color:var(--geaui-tertiary-green-80)}"]
  });
};
SystemStatusDialogComponent = __decorate([ConstructorName('SystemStatusDialogComponent')], SystemStatusDialogComponent);
export { SystemStatusDialogComponent };
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SystemStatusDialogComponent, [{
    type: Component,
    args: [{
      selector: 'geaui-system-status-dialog',
      standalone: true,
      imports: [CommonModule, IconV3Component, TranslateModule, ButtonV2Module, DialogModule],
      template: "<p-dialog [(visible)]=\"showDialog\" [modal]=\"true\" [closable]=\"false\" [showHeader]=\"false\" styleClass=\"system-status-dialog\">\n  <div class=\"system-status-container\">\n    <div class=\"system-message-container\">\n      <geaui-icon-v3 [clickable]=\"false\" [file]=\"iconName\" [color]=\"iconColor\"></geaui-icon-v3>\n      <span class=\"gea-font-heading-20\" [class]=\"severity\">{{ title | translate }}</span>\n      <div class=\"gea-font-body-16\">\n        {{ message | translate }}\n      </div>\n    </div>\n    <geaui-button-v2 [flex]=\"true\" [sending]=\"actionButtonLoading\" (click)=\"onActionButtonClick()\" type=\"secondary\">\n      {{ actionButtonLabel | translate }}\n    </geaui-button-v2>\n  </div>\n</p-dialog>\n",
      styles: [".system-status-container{display:flex;flex-direction:column;padding:40px 0;max-width:368px;gap:40px}.system-status-container .system-message-container{display:flex;flex-direction:column;gap:16px;text-align:center;align-items:center}.system-status-container .error{color:var(--geaui-radiant-orange)}.system-status-container .info{color:var(--geaui-active-blue-120)}.system-status-container .success{color:var(--geaui-tertiary-green-80)}\n"]
    }]
  }], null, {
    showDialog: [{
      type: Input
    }],
    iconName: [{
      type: Input
    }],
    severity: [{
      type: Input
    }],
    title: [{
      type: Input
    }],
    message: [{
      type: Input
    }],
    actionButtonLabel: [{
      type: Input
    }],
    actionButtonLoading: [{
      type: Input
    }],
    actionButtonClicked: [{
      type: Output
    }]
  });
})();
